/**
 * 国际化配置 - vue-i18n
 * 第一阶段：美版(en-US)，后续可扩展其他语言
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import zhCN from 'element-ui/lib/locale/lang/zh-CN'
import en from 'element-ui/lib/locale/lang/en'

import zhCNLocale from './locales/zh-CN'
import enUSLocale from './locales/en-US'

Vue.use(VueI18n)

// 支持的语言列表
export const SUPPORTED_LOCALES = [
  { value: 'zh-CN', label: '简体中文' },
  { value: 'en-US', label: 'English' }
]

// 默认语言
const DEFAULT_LOCALE = 'zh-CN'

// 从 localStorage 读取用户语言偏好
function getStoredLocale() {
  try {
    const stored = localStorage.getItem('APP_LOCALE')
    if (stored && SUPPORTED_LOCALES.some(l => l.value === stored)) {
      return stored
    }
  } catch (e) {
    console.warn('Failed to read locale from localStorage', e)
  }
  return DEFAULT_LOCALE
}

const i18n = new VueI18n({
  locale: getStoredLocale(),
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': {
      ...zhCN,
      ...zhCNLocale,
      // Backward compatibility: lots of code uses `$t('common.xxx')`,
      // but locale keys live under `app.xxx`.
      common: zhCNLocale.app || {}
    },
    'en-US': {
      ...en,
      ...enUSLocale,
      common: enUSLocale.app || {}
    }
  },
  silentTranslationWarn: true // 避免未翻译 key 的警告刷屏
})

// 让 Element UI 使用 vue-i18n
ElementLocale.i18n((key, value) => i18n.t(key, value))

/**
 * 切换语言
 * @param {string} locale - 语言代码，如 'zh-CN' | 'en-US'
 */
export function setLocale(locale) {
  if (!SUPPORTED_LOCALES.some(l => l.value === locale)) {
    console.warn(`Unsupported locale: ${locale}`)
    return
  }
  i18n.locale = locale
  try {
    localStorage.setItem('APP_LOCALE', locale)
  } catch (e) {
    console.warn('Failed to save locale to localStorage', e)
  }
}

/**
 * 获取当前语言
 */
export function getLocale() {
  return i18n.locale
}

/**
 * 根据当前语言获取列宽度
 * 中文直接使用 width,其他语言优先使用对应语言的 Width(如 enWidth),没有则回退到 width
 *
 * @param {string} locale - 当前语言,如 'zh-CN'、'en-US'
 * @param {number} width - 默认宽度(中文使用)
 * @param {number} [enWidth] - 英文宽度(可选)
 * @returns {number} 列宽度
 */
export function getColumnWidth(locale, width, enWidth) {
  if (locale === 'zh-CN') {
    return width
  }
  return enWidth || width
}

// 挂载到 Vue 原型,所有组件可通过 this.$getColumnWidth 使用
Vue.prototype.$getColumnWidth = function(width, enWidth) {
  return getColumnWidth(this.$i18n.locale, width, enWidth)
}

export default i18n
